<template>
    <div class="cs-dropdown-container" ref="dropdownContainer">
        <div class="cs-select-box" @click="toggleDropdown">
            <div class="cs-selected-items">
                <span v-for="category in selected_categories" :key="category.id" class="cs-selected-item">
                    {{ category.name }}
                    <span class="cs-remove-item" @click.stop="removeCategory(category)">x</span>
                </span>
                <span v-if="!selected_categories.length" class="cs-placeholder">Select categories</span>
            </div>
            <span class="cs-arrow">{{ is_open ? '▲' : '▼' }}</span>
        </div>
        <div class="cs-dropdown-content py-2 px-2" v-if="is_open">
            <b>test</b>
            <template v-for="mother_category in mother_categories">
                <custom-category-select-child
                    :category="mother_category"
                    :depth="0"
                    :selected_categories="selected_categories"
                    @selectCategory="selectCategory($event)"
                ></custom-category-select-child>
            </template>

        </div>
    </div>
</template>

<script setup>
import {ref, onMounted, onBeforeUnmount, watch} from 'vue'


const props = defineProps({
    all_categories: Array,
    mother_categories: Array,
    multiselect: {type: Boolean, default: true},
    modelValue: Array
})
const emit = defineEmits(['update:modelValue'])
const dropdownContainer = ref(null);

const selected_categories = ref([]);
const is_open = ref(false)

const mother_categories = props.mother_categories ?? getMotherCategories();

watch(() => props.modelValue, (newVal) => {
    loadModel()
    // is_selected.value = newVal.includes(props.category.id)
})

function updateModel() {
    var selected_ids = selected_categories.value.map(cat => cat.id) ?? [];
    emit('update:modelValue', selected_ids);
}

function loadModel(){
    selected_categories.value = props.modelValue.map(cat_id=>props.all_categories.find((element)=>element.id === cat_id))
}

function getMotherCategories() {
    return props.all_categories.filter(cat => cat.category_id === null);
}

// Toggle the dropdown visibility
function toggleDropdown() {
    is_open.value = !is_open.value;
}


function removeCategory(category) {
    const index = selected_categories.value.findIndex(item => item.id === category.id);
    if (index !== -1) {
        selected_categories.value.splice(index, 1);
    }
    updateModel();
}

function handleClickOutside(event) {
    if (dropdownContainer.value && !dropdownContainer.value.contains(event.target)) {
        is_open.value = false;
    }
}


function findAllParents(category_id) {
    let parents = []
    let category = props.all_categories.find(cat => cat.id === category_id)
    while (category.category_id !== null) {
        category = props.all_categories.find(cat => cat.id === category.category_id)
        parents.push(category.id)
    }
    return parents;
}


function selectCategory(category) {
    if (!props.multiselect) {
        this.selected_categories = [category];
    } else {
        if (this.selected_categories.includes(category)) {
            this.selected_categories = this.selected_categories.filter(cat => cat.id !== category.id)
        } else {
            const parents = findAllParents(category.id)
            //removes all parents from selected_categories
            this.selected_categories = this.selected_categories.filter(cat => parents.includes(cat.id) === false)
            deselectChildren(category)
            this.selected_categories.push(category)
        }
    }
    updateModel();
}


function deselectChildren(category) {
    category.children.forEach(child => {
        selected_categories.value = selected_categories.value.filter(cat => cat.id !== child.id)
        deselectChildren(child)
    })
}


onMounted(() => {
    document.addEventListener('click', handleClickOutside);
    loadModel();

});

onBeforeUnmount(() => {
    document.removeEventListener('click', handleClickOutside);
});

</script>

<style scoped>

.cs-dropdown-container {
    position: relative;
    width: 300px;
}

.cs-select-box {
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
}

.cs-selected-items {
    display: flex;
    flex-wrap: wrap;
}

.cs-selected-item {
    background-color: #007bff;
    color: white;
    border-radius: 12px;
    padding: 5px 10px;
    margin: 2px;
    display: inline-flex;
    align-items: center;
}

.cs-remove-item {
    margin-left: 5px;
    cursor: pointer;
}

.cs-placeholder {
    color: #888;
}

.cs-arrow {
    margin-left: 8px;
}

.cs-dropdown-content {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    border: 1px solid #ccc;
    border-radius: 4px;
    background-color: white;
    z-index: 1000;
    max-height: 200px;
    overflow-y: auto;
    font-size: 16px;

}
</style>
